/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-array-index-key */

import { Button } from 'antd';
import ModalContainer from 'app/components/ModalContainer';
import useWindowSize from 'app/hooks/useWindowSize';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import React, { memo } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import { ReactComponent as CloseIcon } from 'app/assets/img/close_icon.svg';

interface Props {
  isShow: boolean;
  content?: any;
  title?: string;
  onCloseDialog: () => void;
  onConfirm: () => void;
}

const DialogCondition = memo(
  ({ isShow, content, title, onCloseDialog, onConfirm }: Props) => {
    const translations = useSelector(selectTranslations);
    const { device } = useWindowSize();

    return (
      <ModalContainer
        maskClosable={false}
        CloseIcon={
          device === 'mobile' || device === 'tablet' ? (
            <CloseIcon width={11} height={11} />
          ) : undefined
        }
        modalProps={{
          width: 'auto',
          style: {
            overscrollBehavior: 'none',
          },
        }}
        styleSlots={{
          modalContentStyle: {
            ...{
              width: 'auto',
              height: 'auto',
              padding: '40px',
              paddingTop: '30px',
            },
          },
          bodyStyle: {
            ...{
              minHeight: '160px',
              overflow: 'auto',
              padding: '0px',
              width: '98%',
              position: 'relative',
            },
          },
          iconWrapperStyle:
            device === 'mobile' || device === 'tablet'
              ? {
                  margin: '0px 0px 0px 20px',
                }
              : {},
        }}
        closable
        isShow={isShow}
        onCloseDialog={onCloseDialog}
      >
        {content}
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              position: 'absolute',
              bottom: 0,
              width: '100%',
            }}
          >
            <Button
              style={{
                color: '#808080',
                width: '170px',
                height: 48,
                fontWeight: 500,
                fontSize: '14px',
                borderRadius: '10px',
                marginRight: 10,
              }}
              onClick={onCloseDialog}
            >
              <i className="fa-solid fa-arrow-left"></i>
              <span
                className="--textBtn"
                style={{
                  marginLeft: 8,
                }}
              >
                {translations ? translations['b2c.txt.back'] : ''}
              </span>
            </Button>
            <Button
              style={{
                color: 'white',
                width: '170px',
                height: 48,
                fontWeight: 500,
                fontSize: '14px',
                borderRadius: '10px',
                background:
                  'linear-gradient(79.97deg, #F06F24 -7.79%, #F8B117 107.61%)',
              }}
              htmlType="submit"
              onClick={onConfirm}
            >
              <span
                className="--textBtn"
                style={{
                  marginLeft: 8,
                }}
              >
                {translations ? translations['b2c.txt.confirm'] : ''}
              </span>
            </Button>
          </div>
        </>
      </ModalContainer>
    );
  },
);

export default DialogCondition;
